/**
 * Strips any zero width characters
 */
export const stripZeroWidthCharacters = str => `${str}`.replace(/[\u200B-\u200D\uFEFF\u00A0]/g, '');